import styled from 'styled-components'

type Color = 'purple' | 'green' | 'amber' | 'red' | 'gray'

interface Props {
  color?: Color
  children: React.ReactNode
}

const colors: Record<Color, { bg: string; text: string }> = {
  purple: { bg: '#eeedfe', text: '#3c3489' },
  green: { bg: '#eaf3de', text: '#27500a' },
  amber: { bg: '#faeeda', text: '#633806' },
  red: { bg: '#fcebeb', text: '#791f1f' },
  gray: { bg: '#f1efe8', text: '#444441' },
}

const Pill = styled.span<{ $color: Color }>`
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.3px;
  background: ${p => colors[p.$color].bg};
  color: ${p => colors[p.$color].text};
`

export function Badge({ color = 'purple', children }: Props) {
  return <Pill $color={color}>{children}</Pill>
}
